// test522
(522 && 0);
